import {
  ADD_ALL_SCHUELER,
    ADD_SCHUELER,
    UPDATE_SCHUELER,

  } from "./types";
 
  

  export function addAllSchuelerDummy(schueler){
    return async function (dispatch){
      return dispatch(addAllSchueler(schueler))
    }
  }
  function addAllSchueler(schueler){
    return{
      type:ADD_ALL_SCHUELER,
      schueler
    }
  }
  
  export function addSchuelerDummy(schueler){
    return async function (dispatch) {
      return dispatch(addSchueler(schueler));
    }
  };
  function addSchueler(schueler){
    return{
      type: ADD_SCHUELER,
      schueler
    };
  };
  
  export function updateSchuelerDummy(schueler){
    return async function(dispatch){
      return dispatch(updateSchueler(schueler))
    }
  }

  function updateSchueler(schueler){
    return{
      type:UPDATE_SCHUELER,
      schueler
    }
  }
